export default "__VITE_ASSET__BHyStsX3__"